import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  background-color: #F5F5F5;
  padding-bottom: 80px;
`;

export const Header = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  padding: 20px;
`;

export const MainCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const FacilitySection = styled.div`
  display: flex;
  gap: 12px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #F0F0F0;
`;

export const FacilityImage = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const FacilityImagePlaceholder = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  flex-shrink: 0;
`;

export const FacilityInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;

export const FacilityName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: left;
`;

export const FacilityLocation = styled.div`
  font-size: 14px;
  color: #666;
  text-align: left;
`;

export const UsageDate = styled.div`
  font-size: 12px;
  color: #999;
  text-align: right;
  align-self: flex-start;
`;

export const RatingSection = styled.div`
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #F0F0F0;
`;

export const ReviewSection = styled.div`
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #F0F0F0;
`;

export const ImageSection = styled.div`
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #F0F0F0;
`;

export const HashtagSection = styled.div`
  padding-bottom: 0;
`;

export const SectionTitle = styled.div`
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
  text-align: left;
`;

export const StarRatingContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;

export const StarButton = styled.button<{ filled: boolean }>`
  background: transparent;
  border: none;
  font-size: 40px;
  color: ${props => props.filled ? '#FFC107' : '#E0E0E0'};
  cursor: pointer;
  padding: 0;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const ReviewTextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  resize: vertical;
  font-family: inherit;
  box-sizing: border-box;

  &::placeholder {
    color: #999;
  }

  &:focus {
    outline: none;
    border-color: #1FBC70;
  }
`;

export const ImageUploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ImagePreviewContainer = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
`;

export const ImagePreview = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const RemoveImageButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

export const UploadButton = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  border: 2px dashed #E5E5E5;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  color: #666;
  font-size: 14px;

  &:hover {
    border-color: #1FBC70;
    color: #1FBC70;
  }

  input {
    display: none;
  }
`;

export const HashtagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const HashtagButton = styled.button<{ selected: boolean }>`
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid ${props => props.selected ? '#1FBC70' : '#E5E5E5'};
  background: ${props => props.selected ? '#E8F8F0' : 'white'};
  color: ${props => props.selected ? '#1FBC70' : '#666'};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #1FBC70;
    background: ${props => props.selected ? '#E8F8F0' : '#F5F5F5'};
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 16px;
  background: #1FBC70;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #1AAA64;
  }

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    background: #CCCCCC;
    cursor: not-allowed;
  }
`;
